import Hooks from 'core/presentation/hooks';
import ExecutionMode from 'core/base/execution-mode';
import { configRegistry } from 'core/config/config-registry.js';
import { META } from 'core/config/config-factory';
import designStyleDefaultConfig from 'core/generated/configs/_design-style.js';
import MojitoNGen from 'mojito/ngen';
import UIViewUtils from 'core/presentation/ui-view/utils';

configRegistry.add(designStyleDefaultConfig);

const log = MojitoNGen.logger.get('UIViewFamily');

export default function UIViewFamily(name, familyMembers) {
    const MojitoFamilyComponent = props => {
        const { config: parentConfig } = props;
        const appContext = Hooks.useAppContext();
        const viewConfig = Hooks.useConfig(name, parentConfig, appContext.uiContextPath);
        const globalDesignStyle = Hooks.useConfig(
            'DesignStyle',
            undefined,
            appContext.uiContextPath
        );
        const designStyle = viewConfig?.designStyle?.style ?? globalDesignStyle.style;
        const MemberImpl = familyMembers[designStyle];

        if (!MemberImpl) {
            log.error(`No family member found for ${name} style: ${designStyle}.`);
            return null;
        }
        if (ExecutionMode.isDebugMode() && !viewConfig?.[META]?.family) {
            log.error(
                `${name} config is not declared as a config family. Add #@family meta to its yaml, otherwise the family member will receive ${name} config instead of its own.`
            );
        }

        const siblings = Object.entries(familyMembers)
            .filter(([style]) => style !== designStyle)
            .map(([, siblingImpl]) => ({ propTypes: siblingImpl.propTypes }));

        const memberProps = UIViewUtils.omitSiblingProps(
            { props, propTypes: MemberImpl.propTypes },
            siblings
        );

        // The family member resolves its own config against the override chain retained on the family config.
        return <MemberImpl {...memberProps} config={viewConfig} />;
    };

    MojitoFamilyComponent.displayName = `${name}UIViewFamilyWrapper`;

    return MojitoFamilyComponent;
}
